/**
 *
 * @param text - The text to truncate
 * @param length - The length to truncate to
 * @param [truncationSuffix] - The truncation suffix if we need to truncate
 * @returns - The truncated string with the optional suffix included in the max length
 */
export function truncateString(text: string, length: number, truncationSuffix?: string): string {
    if (!text) {
        return '';
    }
    if (text.length <= length) {
        return text;
    } else if (truncationSuffix) {
        return truncateString(text.substr(0, length - truncationSuffix.length) + truncationSuffix, length);
    } else {
        return text.substr(0, length);
    }
}
